export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";